import React from "react";

interface TimeExtensionPopupProps {
  isOpen: boolean;
  onExtend: () => void;
  onClose: () => void;
  extensionMinutes: number;
  message?: string;
}

const TimeExtensionPopup: React.FC<TimeExtensionPopupProps> = ({
  isOpen,
  onExtend,
  onClose,
  extensionMinutes,
  message = "Do you want to extend your quiz time?",
}) => {
  if (!isOpen) return null;
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0,0,0,0.5)',
      zIndex: 2000,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: 500, width: '100%' }}>
        <div className="modal-content">
          <div className="modal-header bg-warning text-dark">
            <h5 className="modal-title fw-bold">
              <i className="fas fa-clock me-2"></i>
              Time Extension Available
            </h5>
          </div>
          <div className="modal-body text-center">
            <div className="mb-3">
              <strong>{message}</strong>
            </div>
            <div className="mt-3 d-flex justify-content-center gap-2">
              <button className="btn btn-success" onClick={onExtend}>
                <i className="fas fa-plus-circle me-1"></i>
                Extend by {extensionMinutes} min
              </button>
              <button className="btn btn-outline-secondary" onClick={onClose}>
                <i className="fas fa-times me-1"></i>
                No, Continue
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimeExtensionPopup;
